<template>
  <div class="vpassinfo">
    <div class="informers_title">
      {{ $tr('profile.password.informers_title') }}:
    </div>
    <div
      v-for="item in informers"
      :key="item.message"
      :class="['pass_' + item.status]"
      class="informers_item"
    >
      {{ item.message }}.
    </div>
  </div>
</template>

<script>
  /*
  @ simple component
  @ props: informers(array)
*/
  export default {
    name: 'vpassinfo',
    props: ['informers']
  };
</script>
<style lang="scss" scoped>
  @import '../../assets/styles/vars.scss';
  .informers_title {
    line-height: 25px;
    font-size: 15px;
  }
  .informers_item {
    line-height: 25px;
    font-size: 15px;
  }
  .pass_error {
    color: $color-error;
    background: url(/static/icons/cross.png) left center no-repeat;
    padding-left: 20px;
  }
  .pass_success {
    color: $color-success;
    background: url(/static/icons/accept.png) left center no-repeat;
    padding-left: 20px;
  }
</style>
